import React from "react";

const OperatorShippingBand = () => {
  return <div>This is operator shipping Band</div>;
};

export default OperatorShippingBand;
